<template>
  <div class="row">
    <div class="col-12 g">
      <div class="am">
        <!-- header -->
        <div class="am-head">
          <div class="am-head-icon"><i class="fa fa-user-secret"></i></div>
          <div class="am-head-text">
            <h4>المشرفون</h4>
            <p>حسابات فرعية تدخل بلوحة المدرسة وتطبيقها، وكل مشرف يرى ما تسمح له به فقط.</p>
          </div>
          <button id="admins-add" class="btn btn-primary am-head-btn" @click="openAdd()">
            <i class="fa fa-plus"></i> إضافة مشرف
          </button>
        </div>

        <div class="am-tools">
          <div class="am-search">
            <i class="fa fa-search"></i>
            <input id="admins-search" v-model.trim="q" type="search" class="form-control" placeholder="ابحث بالاسم أو اسم المستخدم أو الجوال">
          </div>
          <span class="am-count">{{ admins.length }} مشرف</span>
        </div>

        <div v-if="loadError" class="alert alert-danger p-1">{{ loadError }}</div>

        <!-- list -->
        <div v-if="loading && !admins.length" class="am-empty">جاري التحميل...</div>
        <div v-else-if="!admins.length" class="am-empty">
          <i class="fa fa-user-plus"></i>
          <b>لا يوجد مشرفون بعد</b>
          <span>أضف مشرفاً واختر له دوراً جاهزاً مثل «وكيل شؤون الطلاب» أو «مسؤول البوابة».</span>
          <button class="btn btn-primary btn-sm mt-1" @click="openAdd()"><i class="fa fa-plus"></i> إضافة مشرف</button>
        </div>
        <div v-else-if="!rows.length" class="am-empty">لا يوجد مشرف مطابق للبحث.</div>

        <div class="am-list">
          <div v-for="a in rows" :key="a._id" class="am-card">
            <div class="am-card-top">
              <div class="am-avatar" :class="{ all: a.all }">{{ a.initials }}</div>
              <div class="am-card-id">
                <b>{{ a.name || 'بدون اسم' }}</b>
                <span class="am-meta">
                  <span><i class="fa fa-user"></i> <bdi dir="ltr">{{ a.username }}</bdi></span>
                  <span v-if="a.phone"><i class="fa fa-phone"></i> <bdi dir="ltr">{{ a.phone }}</bdi></span>
                  <span v-if="a.joined"><i class="fa fa-calendar"></i> <bdi dir="ltr">{{ a.joined }}</bdi></span>
                </span>
              </div>
              <span class="am-role" :class="{ custom: !a.preset }">{{ a.preset ? a.preset : 'مخصص' }}</span>
            </div>
            <div class="am-chips">
              <span v-for="(c, i) in a.chips" :key="i" class="am-chip" :class="'t-' + (c.tone || 'n')">{{ c.text }}</span>
            </div>
            <div v-if="confirmId == a._id" class="am-confirm" role="alert">
              <span>حذف «{{ a.name }}»؟ لن يستطيع الدخول بعد الحذف.</span>
              <button class="btn btn-danger btn-sm" :disabled="busyId == a._id" @click="removeNow(a._id)">نعم، احذف</button>
              <button class="btn btn-outline-secondary btn-sm" @click="confirmId = ''">إلغاء</button>
            </div>
            <div v-else class="am-card-actions">
              <button class="btn btn-sm btn-primary" @click="openEdit(a._id)"><i class="fa fa-pencil"></i> تعديل</button>
              <button class="btn btn-sm btn-outline-primary" title="إنشاء مشرف جديد بنفس الصلاحيات" @click="openCopy(a._id)"><i class="fa fa-copy"></i> نسخ الصلاحيات</button>
              <button class="btn btn-sm btn-outline-danger am-del" title="حذف المشرف" @click="confirmId = a._id"><i class="fa fa-trash"></i></button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- editor -->
    <b-modal id="admin-editor" size="xl" scrollable body-class="am-modal-body" :title="editorTitle" @hidden="onEditorHidden">
      <div v-if="ed" class="ed">
        <div class="ed-tabs" role="tablist">
          <button v-for="(t, i) in tabs" :key="t.id" role="tab" :aria-selected="ed.tab == t.id ? 'true' : 'false'" class="ed-tab" :class="{ on: ed.tab == t.id, bad: t.id == 'info' && infoInvalid }" @click="ed.tab = t.id">
            <span class="ed-tab-n">{{ i + 1 }}</span> {{ t.title }}
            <small v-if="t.id == 'classes' && ed.pers.indexOf('*') < 0">{{ classesShort }}</small>
          </button>
        </div>

        <div class="ed-grid">
          <div class="ed-main">
            <!-- 1: account -->
            <div v-show="ed.tab == 'info'" class="ed-pane">
              <div class="ed-fields">
                <div class="form-group">
                  <label for="ed-name">اسم المشرف</label>
                  <input id="ed-name" v-model="ed.name" type="text" class="form-control" :class="{ 'is-invalid': errors.name }" placeholder="مثال: أ. خالد العتيبي">
                  <small v-if="errors.name" class="text-danger">{{ errors.name }}</small>
                </div>
                <div class="form-group">
                  <label for="ed-phone">الجوال</label>
                  <input id="ed-phone" v-model="ed.phone" type="tel" inputmode="tel" class="form-control" :class="{ 'is-invalid': errors.phone }" placeholder="05xxxxxxxx" style="direction: ltr; text-align: right">
                  <small v-if="errors.phone" class="text-danger">{{ errors.phone }}</small>
                </div>
                <div class="form-group">
                  <label for="ed-username">اسم المستخدم (للدخول)</label>
                  <input id="ed-username" v-model.trim="ed.username" type="text" autocomplete="off" class="form-control" :class="{ 'is-invalid': errors.username }" :readonly="ed.mode == 'edit'" placeholder="مثال: khaled" style="direction: ltr; text-align: right">
                  <small v-if="errors.username" class="text-danger">{{ errors.username }}</small>
                  <small v-else-if="ed.mode == 'edit'" class="text-muted">لا يمكن تغيير اسم المستخدم بعد الإنشاء.</small>
                </div>
                <div class="form-group">
                  <label for="ed-password">كلمة المرور</label>
                  <div class="ed-pass">
                    <input id="ed-password" v-model.trim="ed.password" :type="ed.showPass ? 'text' : 'password'" autocomplete="new-password" class="form-control" :class="{ 'is-invalid': errors.password }" style="direction: ltr; text-align: right">
                    <button type="button" class="btn btn-outline-secondary" :title="ed.showPass ? 'إخفاء' : 'إظهار'" @click="ed.showPass = !ed.showPass"><i class="fa" :class="ed.showPass ? 'fa-eye-slash' : 'fa-eye'"></i></button>
                    <button type="button" class="btn btn-outline-secondary" title="توليد كلمة مرور" @click="generatePassword()"><i class="fa fa-refresh"></i></button>
                    <button type="button" class="btn btn-outline-secondary" title="نسخ بيانات الدخول" @click="copyLogin()"><i class="fa fa-copy"></i></button>
                  </div>
                  <small v-if="errors.password" class="text-danger">{{ errors.password }}</small>
                  <small v-else-if="ed.mode == 'edit'" class="text-muted">تغيير كلمة المرور يُخرج المشرف من أجهزته، ويدخل بالجديدة.</small>
                </div>
              </div>
              <div class="ed-tip"><i class="fa fa-info-circle"></i> يدخل المشرف بنفس صفحة دخول المدرسة وتطبيق المدرسة باسم المستخدم وكلمة المرور.</div>
            </div>

            <!-- 2: permissions -->
            <div v-show="ed.tab == 'pers'" class="ed-pane">
              <div class="ed-label">ابدأ بدور جاهز ثم عدّل ما تريد</div>
              <div class="ed-presets">
                <button v-for="p in presets" :key="p.id" type="button" class="ed-preset" :class="{ on: currentPresetId == p.id }" :title="p.hint" @click="usePreset(p.id)">
                  <b>{{ p.title }}</b><small>{{ p.hint }}</small>
                </button>
                <span class="ed-preset custom" :class="{ on: !currentPresetId }"><b>مخصص</b><small>اختيارك أنت</small></span>
              </div>

              <div class="ed-hint"><i class="fa fa-lock"></i> إدارة المشرفين متاحة لحساب المدرسة ومن لديه كامل الصلاحيات.</div>

              <div class="ed-copyrow" v-if="otherAdmins.length">
                <label for="ed-copy-from">أو انسخ صلاحيات مشرف:</label>
                <select id="ed-copy-from" v-model="copyFrom" class="form-control form-control-sm" @change="copyFromAdmin()">
                  <option value="">اختر مشرفاً...</option>
                  <option v-for="o in otherAdmins" :key="o._id" :value="o._id">{{ o.name }} ({{ o.username }})</option>
                </select>
              </div>

              <div v-if="isAll" class="ed-allcard">
                <i class="fa fa-shield"></i>
                <div>
                  <b>كامل الصلاحيات</b>
                  <span>يملك هذا المشرف كل شيء في كل الخدمات، ويستطيع إضافة المشرفين وتعديلهم. اختر دوراً آخر لتحديد صلاحياته.</span>
                </div>
              </div>

              <template v-else>
                <div class="ed-psearch">
                  <i class="fa fa-search"></i>
                  <input id="ed-perm-search" v-model.trim="permQ" type="search" class="form-control" placeholder="ابحث عن صلاحية، مثال: الاستئذان أو حذف">
                </div>
                <transition name="fade">
                  <div v-if="notes.length" class="ed-notes" role="status">
                    <i class="fa fa-link"></i>
                    <span v-for="(n, i) in notes" :key="i">{{ n }}</span>
                  </div>
                </transition>

                <div v-if="permQ && !cards.length" class="am-empty small">لا توجد صلاحية بهذا الاسم.</div>

                <section v-for="c in cards" :key="c.key" class="ed-svc" :class="{ off: !c.on && c.service, expired: c.expired }">
                  <header class="ed-svc-head">
                    <span class="ed-svc-icon"><i class="fa" :class="c.icon"></i></span>
                    <div class="ed-svc-title">
                      <b>{{ c.title }}</b>
                      <small v-if="!c.service">{{ c.count }} من {{ c.total }}</small>
                      <small v-else-if="c.on && c.total">{{ c.count }} من {{ c.total }} صلاحية</small>
                      <small v-else-if="c.on">كل صفحات الخدمة</small>
                      <small v-else>غير مفعّلة لهذا المشرف</small>
                    </div>
                    <span v-if="c.expired" class="ed-badge warn">الاشتراك منتهٍ</span>
                    <label v-if="c.service" class="am-switch" :title="c.on ? 'إيقاف الخدمة لهذا المشرف' : 'تفعيل الخدمة لهذا المشرف'">
                      <input type="checkbox" :checked="c.on" :aria-label="'تفعيل ' + c.title" :data-service="c.service" @change="onService(c.service, $event)">
                      <span></span>
                    </label>
                    <button v-if="c.on && c.total" type="button" class="ed-collapse" :aria-expanded="c.open ? 'true' : 'false'" :title="c.open ? 'طي' : 'عرض الصلاحيات'" @click="toggleOpen(c.key)">
                      <i class="fa" :class="c.open ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                    </button>
                  </header>

                  <div v-if="c.orphans" class="ed-orphans">
                    <i class="fa fa-exclamation-triangle"></i>
                    <span>لديه {{ c.orphans }} صلاحيات محفوظة من هذه الخدمة لكن الخدمة غير مفعّلة له، فلا تظهر له.</span>
                    <button type="button" class="btn btn-sm btn-outline-primary" @click="enableServiceOnly(c.service)">تفعيل الخدمة</button>
                    <button type="button" class="btn btn-sm btn-outline-secondary" @click="clearOrphans(c.service)">مسحها</button>
                  </div>

                  <div v-if="(c.on || !c.service) && c.open" class="ed-svc-body">
                    <div v-for="area in c.areas" :key="area.id" class="ed-area">
                      <div class="ed-area-head">
                        <b>{{ area.title }}</b>
                        <button type="button" class="ed-link" @click="onArea(c.service, area.id, !area.allOn)">{{ area.allOn ? 'إلغاء الكل' : 'تحديد الكل' }}</button>
                      </div>
                      <label v-for="it in area.items" :key="it.key" class="ed-row" :class="{ on: it.on }">
                        <span class="ed-row-text">
                          <b>{{ it.title }} <i v-if="it.write" class="fa fa-pencil ed-w" title="يعدّل البيانات"></i></b>
                          <small>{{ it.hint }}<template v-if="it.needs"> · {{ it.needs }}</template></small>
                        </span>
                        <span class="am-switch">
                          <input type="checkbox" :checked="it.on" :aria-label="it.title" :data-key="it.key" @change="onPerm(it.key, $event)">
                          <span></span>
                        </span>
                      </label>
                    </div>
                  </div>
                  <div v-else-if="c.service && c.on && !c.total" class="ed-svc-plain">تفعيل الخدمة يفتح كل صفحاتها لهذا المشرف.</div>
                </section>
              </template>
            </div>

            <!-- 3: classes -->
            <div v-show="ed.tab == 'classes'" class="ed-pane">
              <div v-if="isAll" class="ed-tip"><i class="fa fa-info-circle"></i> صاحب كامل الصلاحيات يرى كل الصفوف دائماً.</div>
              <div v-else-if="!classTitles.length" class="am-empty small">لا توجد صفوف بعد. تظهر هنا بعد إضافة الطلاب.</div>
              <template v-else>
                <p class="ed-explain">
                  يرى المشرف طلاب الصفوف المختارة فقط في قائمة الطلاب وقوائم اختيار الصف وتقارير الحصص.
                  <b>إن لم تختر أي صف فلن يظهر له أي طالب هناك.</b>
                </p>
                <div class="ed-classes">
                  <button type="button" class="ed-class all" :class="{ on: allClassesOn }" :aria-pressed="allClassesOn ? 'true' : 'false'" @click="setAllClasses(!allClassesOn)">
                    <i class="fa" :class="allClassesOn ? 'fa-check-square' : 'fa-square-o'"></i> كل الصفوف ({{ classTitles.length }})
                  </button>
                  <button v-for="t in classTitles" :key="t" type="button" class="ed-class" :class="{ on: ed.pers.indexOf(t) > -1 }" :aria-pressed="ed.pers.indexOf(t) > -1 ? 'true' : 'false'" @click="toggleClass(t)">
                    <i class="fa" :class="ed.pers.indexOf(t) > -1 ? 'fa-check' : 'fa-plus'"></i> {{ t }}
                  </button>
                </div>
                <small class="text-muted d-block mt-1">الصفوف التي تضيفها للمدرسة لاحقاً لا تُضاف للمشرف تلقائياً.</small>
              </template>
            </div>
          </div>

          <!-- live summary -->
          <aside class="ed-side" aria-live="polite">
            <div class="ed-side-head">
              <i class="fa fa-eye"></i>
              <b>ماذا يستطيع هذا المشرف</b>
            </div>
            <div class="ed-side-role">{{ currentPresetTitle }}</div>
            <div v-if="isAll" class="ed-side-all">كل الصفحات والإجراءات في كل الخدمات، وإدارة المشرفين.</div>
            <template v-else>
              <div v-if="!summary.blocks.length" class="ed-side-empty">لم تختر أي صلاحية بعد، فلن يرى المشرف إلا الصفحة الرئيسية.</div>
              <div v-for="b in summary.blocks" :key="b.key" class="ed-side-block">
                <b><i class="fa" :class="b.icon"></i> {{ b.title }}</b>
                <div class="ed-side-items">
                  <span v-for="t in b.shown" :key="t">{{ t }}</span>
                  <span v-if="b.more" class="more"><bdi dir="ltr">+{{ b.more }}</bdi> أخرى</span>
                </div>
              </div>
              <div v-if="summary.classes" class="ed-side-block">
                <b><i class="fa fa-th"></i> الصفوف</b>
                <div class="ed-side-items"><span>{{ summary.classes }}</span></div>
              </div>
            </template>
            <ul v-if="summary.warnings.length" class="ed-warn">
              <li v-for="(w, i) in summary.warnings" :key="i"><i class="fa fa-exclamation-circle"></i> {{ w }}</li>
            </ul>
          </aside>
        </div>
      </div>
      <template #modal-footer>
        <div v-if="ed" class="ed-foot">
          <div v-if="saveError" class="ed-save-error" role="alert"><i class="fa fa-exclamation-circle"></i> {{ saveError }}</div>
          <button v-if="tabIndex > 0" type="button" class="btn btn-outline-secondary ed-nav" title="السابق" @click="goTab(-1)"><i class="fa fa-arrow-right"></i> <span>السابق</span></button>
          <span class="ed-grow"></span>
          <button v-if="tabIndex < tabs.length - 1" type="button" class="btn btn-outline-primary ed-nav" title="التالي" @click="goTab(1)"><span>التالي</span> <i class="fa fa-arrow-left"></i></button>
          <button id="ed-save" type="button" class="btn btn-primary" :disabled="saving" @click="save()">
            <i class="fa" :class="saving ? 'fa-spinner fa-spin' : 'fa-check'"></i>
            {{ ed.mode == 'edit' ? 'حفظ التعديلات' : 'إضافة المشرف' }}
          </button>
        </div>
      </template>
    </b-modal>

    <transition name="fade">
      <div v-if="toast" class="am-toast" :class="toastTone" role="status">{{ toast }}</div>
    </transition>
  </div>
</template>

<script>
import { BModal, VBModal } from "bootstrap-vue";
import { norm } from "@/libs/list-sort";
import {
  CATALOG, PRESETS, ITEMS, groupOf, isCatalogCode,
  toggle, toggleService, toggleArea, normalize, applyPreset, presetOf, humanSummary, shortName, iconOf,
} from "@/libs/permissions";

// Order of the service cards; services not listed come after, as the server lists them.
var ORDER = ['students', 'teachers', 'lessons', 'calls', 'results', 'mentors', 'committees', 'whatsapp', 'table', 'masrufi'];

export default {
  components: { BModal },
  directives: { "b-modal": VBModal },
  data() {
    return {
      user: JSON.parse(localStorage.getItem('user')),
      admins: [],
      services: [],
      classes: [],
      loading: true,
      loadError: '',
      q: '',
      confirmId: '',
      busyId: '',
      ed: null,
      errors: {},
      permQ: '',
      notes: [],
      noteTimer: null,
      open: {},
      copyFrom: '',
      saving: false,
      saveError: '',
      toast: '',
      toastTone: '',
      toastTimer: null,
      presets: PRESETS,
      tabs: [
        { id: 'info', title: 'البيانات' },
        { id: 'pers', title: 'الصلاحيات' },
        { id: 'classes', title: 'الصفوف' },
      ],
    };
  },
  computed: {
    serviceCodes() {
      return this.services.map(function(s) { return s.service; });
    },
    classTitles() {
      return this.classes.map(function(c) { return c.title; });
    },
    rows() {
      var g = this, q = norm(this.q);
      return this.admins.filter(function(a) {
        if (!q) return true;
        return [a.name, a.username, a.phone].some(function(x) { return norm(x).indexOf(q) > -1; });
      }).map(function(a) {
        var pers = a.pers || [];
        var p = presetOf(pers, g.serviceCodes, g.classTitles);
        return {
          _id: a._id,
          name: a.name,
          username: a.username,
          phone: a.phone,
          joined: (a.joindate || '').split(' ')[0],
          initials: g.initials(a.name),
          all: pers.indexOf('*') > -1,
          preset: p ? p.title : '',
          chips: humanSummary(pers, g.services, g.classTitles),
        };
      });
    },
    editorTitle() {
      if (!this.ed) return '';
      if (this.ed.mode == 'edit') return 'تعديل المشرف: ' + (this.ed.name || '');
      return this.ed.copyOf ? 'مشرف جديد بنفس صلاحيات ' + this.ed.copyOf : 'إضافة مشرف';
    },
    tabIndex() {
      var g = this;
      return this.ed ? this.tabs.findIndex(function(t) { return t.id == g.ed.tab; }) : 0;
    },
    infoInvalid() {
      return !!(this.errors.name || this.errors.username || this.errors.password || this.errors.phone);
    },
    isAll() {
      return !!this.ed && this.ed.pers.indexOf('*') > -1;
    },
    currentPreset() {
      return this.ed ? presetOf(this.ed.pers, this.serviceCodes, this.classTitles) : null;
    },
    currentPresetId() {
      return this.currentPreset ? this.currentPreset.id : '';
    },
    currentPresetTitle() {
      return this.currentPreset ? 'الدور: ' + this.currentPreset.title : 'الدور: مخصص';
    },
    otherAdmins() {
      var g = this;
      return this.admins.filter(function(a) { return !g.ed || a._id != g.ed.id; });
    },
    allClassesOn() {
      var g = this;
      return this.classTitles.length > 0 && this.classTitles.every(function(t) { return g.ed && g.ed.pers.indexOf(t) > -1; });
    },
    selectedClasses() {
      var g = this;
      return this.ed ? this.classTitles.filter(function(t) { return g.ed.pers.indexOf(t) > -1; }) : [];
    },
    classesShort() {
      if (!this.classTitles.length) return '';
      if (this.allClassesOn) return '(الكل)';
      return '(' + this.selectedClasses.length + ')';
    },
    // the permission cards: general first, then each service the school has
    cards() {
      if (!this.ed) return [];
      var g = this, pers = this.ed.pers, q = norm(this.permQ), out = [];
      var list = this.sortedServices.concat([{ service: '', title: 'صلاحيات عامة', valid: true }]);
      list.forEach(function(s) {
        var group = groupOf(s.service);
        var areas = (group ? group.areas : []).map(function(area) {
          var items = area.items.filter(function(it) {
            return !q || norm(it.title + ' ' + it.hint + ' ' + area.title).indexOf(q) > -1;
          }).map(function(it) {
            return {
              key: it.key,
              title: it.title,
              hint: it.hint,
              write: it.write,
              on: pers.indexOf(it.key) > -1,
              needs: g.needsText(it),
            };
          });
          return {
            id: area.id,
            title: area.title,
            items: items,
            allOn: area.items.every(function(it) { return pers.indexOf(it.key) > -1; }),
          };
        }).filter(function(a) { return a.items.length; });
        var all = [];
        (group ? group.areas : []).forEach(function(a) { all = all.concat(a.items); });
        var on = !s.service || pers.indexOf(s.service) > -1;
        var count = all.filter(function(it) { return pers.indexOf(it.key) > -1; }).length;
        if (q && !areas.length && norm(s.title).indexOf(q) < 0) return;
        out.push({
          key: s.service || 'general',
          service: s.service,
          title: s.title,
          icon: s.service ? iconOf(s.service) : 'fa-sliders',
          on: on,
          expired: s.service && !s.valid,
          total: all.length,
          count: count,
          orphans: on ? 0 : count,
          areas: areas,
          open: !!q || g.open[s.service || 'general'] !== false,
        });
      });
      return out;
    },
    sortedServices() {
      return this.services.slice().sort(function(a, b) {
        var x = ORDER.indexOf(a.service), y = ORDER.indexOf(b.service);
        return (x < 0 ? 99 : x) - (y < 0 ? 99 : y);
      });
    },
    // «ماذا يستطيع هذا المشرف»
    summary() {
      var out = { blocks: [], classes: '', warnings: [] };
      if (!this.ed) return out;
      var g = this, pers = this.ed.pers;
      [{ service: '', title: 'صلاحيات عامة', valid: true }].concat(this.sortedServices).forEach(function(s) {
        var group = groupOf(s.service), titles = [];
        (group ? group.areas : []).forEach(function(a) {
          a.items.forEach(function(it) { if (pers.indexOf(it.key) > -1) titles.push(it.title); });
        });
        if (s.service && pers.indexOf(s.service) < 0) {
          if (titles.length && !g.isAll) out.warnings.push('خدمة «' + s.title + '» غير مفعّلة له، فلا تعمل ' + titles.length + ' صلاحيات محفوظة منها.');
          return;
        }
        if (!s.service && !titles.length) return;
        if (s.service && !group) titles = ['كل صفحات الخدمة'];
        if (s.service && group && !titles.length) titles = ['قائمة الخدمة فقط، بدون صفحات'];
        out.blocks.push({ key: s.service || 'general', title: s.service ? shortName(s) : 'عامة', icon: s.service ? iconOf(s.service) : 'fa-sliders', shown: titles.slice(0, 8), more: Math.max(0, titles.length - 8) });
        if (s.service && !s.valid) out.warnings.push('اشتراك خدمة «' + s.title + '» منتهٍ، فلن تعمل صلاحياتها حتى التجديد.');
      });
      if (this.isAll) return out;
      if (this.classTitles.length && (pers.indexOf('students') > -1 || pers.indexOf('lessons') > -1)) {
        if (this.allClassesOn) out.classes = 'كل الصفوف (' + this.classTitles.length + ')';
        else if (this.selectedClasses.length) out.classes = this.selectedClasses.join('، ');
        else out.warnings.push('لم تختر أي صف: لن يظهر له أي طالب في قائمة الطلاب واختيار الصف.');
      }
      var others = pers.filter(function(x) {
        return !isCatalogCode(x) && g.serviceCodes.indexOf(x) < 0 && g.classTitles.indexOf(x) < 0 && !groupOf(x);
      });
      if (others.length) out.warnings.push('صلاحيات أخرى محفوظة لا تظهر في هذه الصفحة (' + others.length + ')، تبقى كما هي.');
      return out;
    },
  },
  created() {
    if (!checkPer("admins")) {
      this.$router.push('/NotPermitted');
      return false;
    }
    this.load();
  },
  beforeDestroy() {
    clearTimeout(this.noteTimer);
    clearTimeout(this.toastTimer);
  },
  methods: {
    post(path, body) {
      return $.post(api + path, Object.assign({ jwt: this.user.jwt }, body || {}));
    },
    load() {
      var g = this;
      g.loading = true;
      g.loadError = '';
      g.getAdmins();
      g.post('/user/students/classes').then(function(r) {
        g.classes = r.status == 100 && Array.isArray(r.response) ? r.response : [];
      });
      g.post('/user/subscribe/subscribes').then(function(r) {
        if (r.status != 100) return;
        g.services = (r.response || []).map(function(s) {
          return { service: s.service, title: s.title, valid: new Date(s.exdate) > new Date() };
        });
      });
    },
    getAdmins() {
      var g = this;
      g.post('/user/admins/list').then(function(r) {
        g.loading = false;
        if (r.status == 100) g.admins = r.response || [];
        else g.loadError = r.response;
      }).fail(function() {
        g.loading = false;
        g.loadError = 'تعذر الاتصال بالخادم، تحقق من الإنترنت ثم حدّث الصفحة.';
      });
    },
    initials(name) {
      var w = (name || '').replace(/^(أ\.|أ\/|الأستاذ|الاستاذ|م\.|د\.)\s*/, '').trim().split(/\s+/);
      return ((w[0] || '؟').charAt(0) + (w[1] ? w[1].charAt(0) : '')).trim();
    },
    needsText(it) {
      if (it.requires && it.requires.length && ITEMS[it.requires[0]]) return 'تحتاج «' + ITEMS[it.requires[0]].title + '»';
      if (it.needsOne) return 'تحتاج تقريراً يومياً أو لفترة';
      return '';
    },
    // ---------------- editor
    openEditor(ed) {
      this.ed = Object.assign({ tab: 'info', showPass: false }, ed);
      this.errors = {};
      this.permQ = '';
      this.notes = [];
      this.open = {};
      this.copyFrom = '';
      this.saveError = '';
      this.$bvModal.show('admin-editor');
    },
    openAdd() {
      this.openEditor({ mode: 'add', id: '', name: '', username: '', password: this.newPassword(), phone: '', pers: this.classTitles.slice() });
    },
    openEdit(id) {
      var a = this.find(id);
      if (!a) return;
      this.openEditor({ mode: 'edit', id: a._id, name: a.name || '', username: a.username || '', password: a.password || '', phone: a.phone || '', pers: (a.pers || []).slice() });
      this.ed.tab = 'pers';
    },
    openCopy(id) {
      var a = this.find(id);
      if (!a) return;
      this.openEditor({ mode: 'add', id: '', name: '', username: '', password: this.newPassword(), phone: '', pers: (a.pers || []).slice(), copyOf: a.name });
    },
    onEditorHidden() {
      this.ed = null;
    },
    find(id) {
      return this.admins.filter(function(a) { return a._id == id; })[0];
    },
    goTab(step) {
      var i = Math.min(this.tabs.length - 1, Math.max(0, this.tabIndex + step));
      if (this.ed.tab == 'info' && step > 0 && !this.validate()) return;
      this.ed.tab = this.tabs[i].id;
    },
    validate() {
      var e = {}, ed = this.ed;
      if (!(ed.name || '').trim()) e.name = 'اكتب اسم المشرف.';
      if (ed.mode == 'add') {
        if (!ed.username) e.username = 'اكتب اسم مستخدم يدخل به المشرف.';
        else if (/\s/.test(ed.username)) e.username = 'اسم المستخدم بدون مسافات.';
        if (!(ed.phone || '').trim()) e.phone = 'اكتب جوال المشرف.';
      }
      if (!ed.password) e.password = 'اكتب كلمة مرور أو ولّد واحدة.';
      else if (ed.password.length < 4) e.password = 'كلمة المرور 4 أحرف على الأقل.';
      this.errors = e;
      return !Object.keys(e).length;
    },
    newPassword() {
      var chars = 'abcdefghjkmnpqrstuvwxyz23456789', out = '';
      var rnd = window.crypto && window.crypto.getRandomValues ? window.crypto.getRandomValues(new Uint32Array(8)) : null;
      for (var i = 0; i < 8; i++) out += chars.charAt((rnd ? rnd[i] : Math.floor(Math.random() * 1e9)) % chars.length);
      return out;
    },
    generatePassword() {
      this.ed.password = this.newPassword();
      this.ed.showPass = true;
    },
    copyLogin() {
      var text = 'اسم المستخدم: ' + (this.ed.username || '') + '\nكلمة المرور: ' + (this.ed.password || '');
      var g = this;
      var done = function() { g.showToast('نُسخت بيانات الدخول', 'ok'); };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(done).catch(function() { g.copyFallback(text); done(); });
      } else {
        g.copyFallback(text);
        done();
      }
    },
    copyFallback(text) {
      var t = document.createElement('textarea');
      t.value = text;
      document.body.appendChild(t);
      t.select();
      try { document.execCommand('copy'); } catch (e) { /* nothing to do */ }
      document.body.removeChild(t);
    },
    setPers(result) {
      this.ed.pers = result.pers;
      this.showNotes(result.notes);
    },
    onPerm(key, e) {
      this.setPers(toggle(this.ed.pers, key, e.target.checked));
    },
    onService(service, e) {
      var on = e.target.checked;
      this.setPers(toggleService(this.ed.pers, service, on));
      if (on) this.$set(this.open, service, true);
    },
    onArea(service, areaId, on) {
      this.setPers(toggleArea(this.ed.pers, service, areaId, on));
    },
    toggleOpen(key) {
      this.$set(this.open, key, this.open[key] === false);
    },
    enableServiceOnly(service) {
      this.ed.pers = normalize(this.ed.pers.concat([service]));
    },
    clearOrphans(service) {
      var g = groupOf(service), pers = this.ed.pers.slice();
      (g ? g.areas : []).forEach(function(a) {
        a.items.forEach(function(it) {
          [it.key].concat(it.also || []).forEach(function(k) {
            var i = pers.indexOf(k);
            if (i > -1) pers.splice(i, 1);
          });
        });
      });
      this.ed.pers = normalize(pers);
    },
    usePreset(id) {
      this.ed.pers = applyPreset(this.ed.pers, id, this.serviceCodes, this.classTitles);
      this.notes = [];
    },
    copyFromAdmin() {
      var a = this.find(this.copyFrom);
      if (a) {
        this.ed.pers = (a.pers || []).slice();
        this.showNotes(['نُسخت صلاحيات «' + a.name + '» وصفوفه']);
      }
      this.copyFrom = '';
    },
    showNotes(notes) {
      var g = this;
      clearTimeout(this.noteTimer);
      this.notes = notes || [];
      if (this.notes.length) this.noteTimer = setTimeout(function() { g.notes = []; }, 6000);
    },
    toggleClass(t) {
      var pers = this.ed.pers.slice(), i = pers.indexOf(t);
      if (i > -1) pers.splice(i, 1);
      else pers.push(t);
      this.ed.pers = pers;
    },
    setAllClasses(on) {
      var titles = this.classTitles;
      var pers = this.ed.pers.filter(function(x) { return titles.indexOf(x) < 0; });
      this.ed.pers = on ? pers.concat(titles) : pers;
    },
    save() {
      var g = this, ed = this.ed;
      if (!this.validate()) {
        ed.tab = 'info';
        return;
      }
      g.saving = true;
      g.saveError = '';
      var pers = normalize(ed.pers);
      var body = { name: ed.name.trim(), phone: (ed.phone || '').trim(), password: ed.password, pers: pers.join(',') };
      if (ed.mode == 'edit') body.id = ed.id;
      else body.username = ed.username;
      g.post(ed.mode == 'edit' ? '/user/admins/edit' : '/user/admins/add', body).then(function(r) {
        g.saving = false;
        if (r.status == 100) {
          g.$bvModal.hide('admin-editor');
          g.showToast(ed.mode == 'edit' ? 'حُفظت تعديلات المشرف' : 'أُضيف المشرف، أرسل له بيانات الدخول', 'ok');
          g.getAdmins();
        } else {
          g.saveError = r.response || 'تعذر الحفظ، حاول مرة أخرى.';
          if (/المستخدم/.test(g.saveError)) {
            g.$set(g.errors, 'username', g.saveError);
            ed.tab = 'info';
          }
        }
      }).fail(function() {
        g.saving = false;
        g.saveError = 'تعذر الاتصال بالخادم، حاول مرة أخرى.';
      });
    },
    removeNow(id) {
      var g = this;
      g.busyId = id;
      g.post('/user/admins/delete', { id: id }).then(function(r) {
        g.busyId = '';
        g.confirmId = '';
        if (r.status == 100) {
          g.showToast('حُذف المشرف', 'ok');
          g.getAdmins();
        } else {
          g.showToast(r.response || 'تعذر الحذف', 'bad');
        }
      }).fail(function() {
        g.busyId = '';
        g.showToast('تعذر الاتصال بالخادم', 'bad');
      });
    },
    showToast(text, tone) {
      var g = this;
      clearTimeout(this.toastTimer);
      this.toast = text;
      this.toastTone = tone == 'bad' ? 'bad' : 'ok';
      this.toastTimer = setTimeout(function() { g.toast = ''; }, 3500);
    },
  },
};
</script>

<style scoped>
.am {
  --am-gap: 14px;
}
.am-head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 14px;
  margin-bottom: 16px;
}
.am-head-icon {
  width: 46px;
  height: 46px;
  border-radius: 14px;
  display: grid;
  place-items: center;
  font-size: 22px;
  color: var(--sk-p, #1D4ED8);
  background: var(--sk-ps, #E8EEFD);
  flex-shrink: 0;
}
.am-head-text {
  flex: 1;
  min-width: 220px;
}
.am-head-text h4 {
  margin: 0 0 2px;
  font-weight: 700;
  color: var(--sk-ink, #0F1733);
}
.am-head-text p {
  margin: 0;
  color: var(--sk-muted, #667085);
  font-size: 13px;
}
.am-head-btn {
  border-radius: 12px;
  font-weight: 600;
  white-space: nowrap;
}
.am-tools {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
}
.am-search, .ed-psearch {
  position: relative;
  flex: 1;
  max-width: 460px;
}
.am-search i, .ed-psearch i {
  position: absolute;
  top: 50%;
  inset-inline-start: 12px;
  margin-top: -7px;
  color: var(--sk-faint, #98A2B3);
  font-size: 14px;
}
.am-search input, .ed-psearch input {
  padding-inline-start: 34px;
  border-radius: 12px;
  background: var(--sk-card, #fff);
}
.am-count {
  color: var(--sk-muted, #667085);
  font-size: 13px;
  white-space: nowrap;
}
.am-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 36px 16px;
  text-align: center;
  color: var(--sk-muted, #667085);
  background: var(--sk-card, #fff);
  border: 1px dashed var(--sk-line, #D5DAE3);
  border-radius: 16px;
}
.am-empty i {
  font-size: 30px;
  color: var(--sk-p, #1D4ED8);
}
.am-empty b {
  color: var(--sk-ink, #0F1733);
}
.am-empty.small {
  padding: 18px 12px;
}
.am-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));
  gap: var(--am-gap);
}
.am-card {
  background: var(--sk-card, #fff);
  border: 1px solid var(--sk-line2, #E6E9EF);
  border-radius: 16px;
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  box-shadow: var(--sk-shadow);
}
.am-card-top {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}
.am-avatar {
  width: 44px;
  height: 44px;
  border-radius: 14px;
  display: grid;
  place-items: center;
  font-weight: 700;
  font-size: 16px;
  color: var(--sk-pi, #1E3A8A);
  background: var(--sk-ps, #E8EEFD);
  flex-shrink: 0;
}
.am-avatar.all {
  color: #fff;
  background: var(--sk-p, #1D4ED8);
}
.am-card-id {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.am-card-id b {
  color: var(--sk-ink, #0F1733);
  font-size: 15px;
}
.am-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 12px;
  color: var(--sk-muted, #667085);
  font-size: 12px;
}
.am-meta i {
  color: var(--sk-faint, #98A2B3);
}
.am-role {
  font-size: 11.5px;
  font-weight: 700;
  padding: 4px 10px;
  border-radius: 999px;
  color: var(--sk-pi, #1E3A8A);
  background: var(--sk-ps, #E8EEFD);
  white-space: nowrap;
}
.am-role.custom {
  color: var(--sk-text, #344054);
  background: var(--sk-soft2, #EEF1F6);
}
.am-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.am-chip {
  font-size: 12px;
  padding: 3px 9px;
  border-radius: 8px;
  background: var(--sk-soft, #F6F7FB);
  color: var(--sk-text, #344054);
  border: 1px solid var(--sk-line2, #E6E9EF);
}
.am-chip.t-all {
  background: var(--sk-oks, #DCFAE6);
  color: var(--sk-oki, #067647);
  border-color: transparent;
}
.am-chip.t-read {
  background: var(--sk-ins, #E0F2FE);
  color: var(--sk-ini, #026AA2);
  border-color: transparent;
}
.am-chip.t-warn {
  background: var(--sk-was, #FEF0C7);
  color: var(--sk-wai, #B54708);
  border-color: transparent;
}
.am-card-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: auto;
}
.am-card-actions .btn {
  border-radius: 10px;
}
.am-del {
  margin-inline-start: auto;
}
.am-confirm {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  padding: 10px;
  border-radius: 12px;
  background: var(--sk-bads, #FEE4E2);
  color: var(--sk-badi, #B42318);
  font-size: 13px;
}
.am-confirm span {
  flex: 1 1 100%;
}
.am-toast {
  position: fixed;
  top: calc(16px + env(safe-area-inset-top, 0px));
  left: 50%;
  transform: translateX(-50%);
  z-index: 2000;
  padding: 10px 18px;
  border-radius: 12px;
  color: #fff;
  font-weight: 600;
  box-shadow: var(--sk-pop);
  max-width: calc(100vw - 32px);
}
.am-toast.ok { background: var(--sk-oki, #067647); }
.am-toast.bad { background: var(--sk-badi, #B42318); }

/* switch (same look as app-settings) */
.am-switch {
  position: relative;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  margin: 0;
  flex-shrink: 0;
  user-select: none;
}
.am-switch input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}
.am-switch > span {
  width: 40px;
  height: 22px;
  border-radius: 999px;
  background: var(--sk-field, #BFC6D1);
  position: relative;
  transition: background .15s;
}
.am-switch > span::after {
  content: '';
  position: absolute;
  top: 3px;
  inset-inline-start: 3px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, .2);
  transition: transform .15s;
}
.am-switch input:checked + span {
  background: var(--sk-p, #1D4ED8);
}
[dir="rtl"] .am-switch input:checked + span::after {
  transform: translateX(-18px);
}
[dir="ltr"] .am-switch input:checked + span::after {
  transform: translateX(18px);
}
.am-switch input:focus-visible + span {
  outline: 2px solid var(--sk-p, #1D4ED8);
  outline-offset: 2px;
}

/* editor */
.ed-tabs {
  display: flex;
  gap: 6px;
  padding: 4px;
  background: var(--sk-soft2, #EEF1F6);
  border-radius: 14px;
  margin-bottom: 14px;
}
.ed-tab {
  flex: 1;
  border: 0;
  background: transparent;
  padding: 9px 12px;
  border-radius: 10px;
  font-weight: 600;
  font-size: 13.5px;
  color: var(--sk-muted, #667085);
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
.ed-tab.on {
  background: var(--sk-card, #fff);
  color: var(--sk-p, #1D4ED8);
  box-shadow: var(--sk-shadow);
}
.ed-tab.bad {
  color: var(--sk-bad, #D92D20);
}
.ed-tab:focus-visible {
  outline: 2px solid var(--sk-p, #1D4ED8);
}
.ed-tab-n {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: inline-grid;
  place-items: center;
  font-size: 11px;
  background: var(--sk-line2, #E6E9EF);
  color: var(--sk-text, #344054);
}
.ed-tab.on .ed-tab-n {
  background: var(--sk-p, #1D4ED8);
  color: #fff;
}
.ed-tab small {
  font-weight: 500;
}
.ed-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 290px;
  gap: 16px;
  align-items: start;
}
.ed-fields {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0 14px;
}
.ed-pass {
  display: flex;
  gap: 6px;
}
.ed-pass .btn {
  padding: 0 11px;
  border-radius: 10px;
}
.ed-tip {
  display: flex;
  gap: 8px;
  align-items: flex-start;
  font-size: 12.5px;
  color: var(--sk-ini, #026AA2);
  background: var(--sk-ins, #E0F2FE);
  padding: 10px 12px;
  border-radius: 12px;
}
.ed-label {
  font-size: 13px;
  font-weight: 700;
  color: var(--sk-ink, #0F1733);
  margin-bottom: 8px;
}
.ed-presets {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 8px;
  margin-bottom: 12px;
}
.ed-preset {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  text-align: start;
  border: 1.5px solid var(--sk-line, #D5DAE3);
  background: var(--sk-card, #fff);
  border-radius: 12px;
  padding: 9px 11px;
  cursor: pointer;
}
.ed-preset b {
  font-size: 13px;
  color: var(--sk-ink, #0F1733);
}
.ed-preset small {
  font-size: 11.5px;
  color: var(--sk-muted, #667085);
  line-height: 1.5;
}
.ed-preset.on {
  border-color: var(--sk-p, #1D4ED8);
  background: var(--sk-ps, #E8EEFD);
}
.ed-preset.custom {
  cursor: default;
  border-style: dashed;
}
.ed-preset:focus-visible {
  outline: 2px solid var(--sk-p, #1D4ED8);
}
.ed-hint {
  font-size: 12px;
  color: var(--sk-muted, #667085);
  margin: -4px 0 10px;
}
.ed-hint i {
  color: var(--sk-faint, #98A2B3);
}
.ed-copyrow {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  font-size: 13px;
  color: var(--sk-muted, #667085);
}
.ed-copyrow label {
  margin: 0;
}
.ed-copyrow select {
  max-width: 280px;
  border-radius: 10px;
}
.ed-allcard {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  padding: 16px;
  border-radius: 14px;
  background: var(--sk-oks, #DCFAE6);
  color: var(--sk-oki, #067647);
}
.ed-allcard i {
  font-size: 26px;
}
.ed-allcard div {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 13px;
}
.ed-psearch {
  max-width: none;
  margin-bottom: 10px;
}
.ed-notes {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 10px;
  align-items: center;
  font-size: 12.5px;
  padding: 8px 12px;
  border-radius: 10px;
  margin-bottom: 10px;
  background: var(--sk-was, #FEF0C7);
  color: var(--sk-wai, #B54708);
}
.ed-svc {
  border: 1px solid var(--sk-line2, #E6E9EF);
  border-radius: 14px;
  background: var(--sk-card, #fff);
  margin-bottom: 10px;
  overflow: hidden;
}
.ed-svc-head {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 11px 12px;
}
.ed-svc.off .ed-svc-head {
  background: var(--sk-soft, #F6F7FB);
}
.ed-svc-icon {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: grid;
  place-items: center;
  color: var(--sk-p, #1D4ED8);
  background: var(--sk-ps, #E8EEFD);
  flex-shrink: 0;
}
.ed-svc.off .ed-svc-icon {
  color: var(--sk-faint, #98A2B3);
  background: var(--sk-soft2, #EEF1F6);
}
.ed-svc-title {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}
.ed-svc-title b {
  color: var(--sk-ink, #0F1733);
  font-size: 14px;
}
.ed-svc-title small {
  color: var(--sk-muted, #667085);
  font-size: 12px;
}
.ed-badge {
  font-size: 11px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 999px;
  white-space: nowrap;
}
.ed-badge.warn {
  background: var(--sk-was, #FEF0C7);
  color: var(--sk-wai, #B54708);
}
.ed-collapse {
  border: 0;
  background: transparent;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  color: var(--sk-muted, #667085);
}
.ed-collapse:hover {
  background: var(--sk-soft2, #EEF1F6);
}
.ed-orphans {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  font-size: 12.5px;
  background: var(--sk-was, #FEF0C7);
  color: var(--sk-wai, #B54708);
}
.ed-orphans span {
  flex: 1 1 260px;
}
.ed-svc-body {
  border-top: 1px solid var(--sk-line2, #E6E9EF);
  padding: 4px 12px 8px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0 18px;
}
.ed-svc-plain {
  border-top: 1px solid var(--sk-line2, #E6E9EF);
  padding: 10px 12px;
  font-size: 12.5px;
  color: var(--sk-muted, #667085);
}
.ed-area {
  padding-top: 8px;
}
.ed-area-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding-bottom: 4px;
  border-bottom: 1px solid var(--sk-line2, #E6E9EF);
}
.ed-area-head b {
  font-size: 12px;
  letter-spacing: .2px;
  color: var(--sk-muted, #667085);
}
.ed-link {
  border: 0;
  background: transparent;
  color: var(--sk-p, #1D4ED8);
  font-size: 12px;
  font-weight: 600;
  padding: 2px 4px;
}
.ed-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 8px 0;
  margin: 0;
  cursor: pointer;
  border-bottom: 1px dashed var(--sk-line2, #E6E9EF);
}
.ed-row:last-child {
  border-bottom: 0;
}
.ed-row-text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.ed-row-text b {
  font-size: 13px;
  font-weight: 600;
  color: var(--sk-text, #344054);
}
.ed-row.on .ed-row-text b {
  color: var(--sk-ink, #0F1733);
}
.ed-row-text small {
  font-size: 11.5px;
  color: var(--sk-muted, #667085);
  line-height: 1.5;
}
.ed-w {
  font-size: 10px;
  color: var(--sk-faint, #98A2B3);
}
.ed-explain {
  font-size: 13px;
  color: var(--sk-text, #344054);
  line-height: 1.8;
}
.ed-classes {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.ed-class {
  border: 1.5px solid var(--sk-line, #D5DAE3);
  background: var(--sk-card, #fff);
  border-radius: 10px;
  padding: 7px 12px;
  font-size: 13px;
  color: var(--sk-text, #344054);
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.ed-class i {
  font-size: 11px;
  color: var(--sk-faint, #98A2B3);
}
.ed-class.on {
  border-color: var(--sk-p, #1D4ED8);
  background: var(--sk-ps, #E8EEFD);
  color: var(--sk-pi, #1E3A8A);
  font-weight: 600;
}
.ed-class.on i {
  color: var(--sk-p, #1D4ED8);
}
.ed-class.all {
  font-weight: 700;
}
.ed-class:focus-visible {
  outline: 2px solid var(--sk-p, #1D4ED8);
}
.ed-side {
  position: sticky;
  top: 0;
  border-radius: 14px;
  background: var(--sk-soft, #F6F7FB);
  border: 1px solid var(--sk-line2, #E6E9EF);
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-size: 12.5px;
}
.ed-side-head {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--sk-ink, #0F1733);
}
.ed-side-head i {
  color: var(--sk-p, #1D4ED8);
}
.ed-side-role {
  font-weight: 700;
  color: var(--sk-pi, #1E3A8A);
}
.ed-side-all, .ed-side-empty {
  color: var(--sk-muted, #667085);
}
.ed-side-block b {
  display: block;
  font-size: 12.5px;
  color: var(--sk-ink, #0F1733);
  margin-bottom: 4px;
}
.ed-side-block b i {
  color: var(--sk-faint, #98A2B3);
  width: 16px;
}
.ed-side-items {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}
.ed-side-items span {
  background: var(--sk-card, #fff);
  border: 1px solid var(--sk-line2, #E6E9EF);
  border-radius: 7px;
  padding: 2px 7px;
  font-size: 11.5px;
  color: var(--sk-text, #344054);
}
.ed-side-items span.more {
  color: var(--sk-muted, #667085);
  border-style: dashed;
}
.ed-warn {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.ed-warn li {
  color: var(--sk-wai, #B54708);
  background: var(--sk-was, #FEF0C7);
  padding: 7px 9px;
  border-radius: 9px;
  line-height: 1.6;
}
.ed-foot {
  width: 100%;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}
.ed-foot .btn {
  border-radius: 10px;
  font-weight: 600;
}
.ed-grow {
  flex: 1;
}
.ed-save-error {
  flex: 1 1 100%;
  color: var(--sk-badi, #B42318);
  background: var(--sk-bads, #FEE4E2);
  padding: 8px 12px;
  border-radius: 10px;
  font-size: 13px;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

@media (max-width: 991px) {
  .ed-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .ed-side {
    position: static;
  }
}
@media (max-width: 640px) {
  .am-list {
    grid-template-columns: minmax(0, 1fr);
  }
  .ed-fields, .ed-svc-body {
    grid-template-columns: minmax(0, 1fr);
  }
  .am-head-btn {
    width: 100%;
  }
  .ed-tab {
    padding: 8px 4px;
    font-size: 12.5px;
    gap: 4px;
  }
  .ed-tab small {
    display: none;
  }
  .ed-presets {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .ed-preset small {
    display: none;
  }
  .ed-preset {
    padding: 8px 10px;
  }
  .ed-nav span {
    display: none;
  }
  .ed-foot .btn {
    padding-inline: 12px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .am-switch > span, .am-switch > span::after, .fade-enter-active, .fade-leave-active {
    transition: none;
  }
}
</style>
